import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";

export const DarkGreenButton = ({
  handleUploadClick,
  title,
  maxWidth,
}: {
  maxWidth?: string;
  title: string;
  handleUploadClick: (event: React.MouseEvent<HTMLElement> | void) => void;
}) => {
  return (
    <Button
      variant="contained"
      startIcon={
        <AddCircleIcon
          sx={{ color: "#ffffff !important", fill: "#ffffff !important" }}
        />
      }
      onClick={handleUploadClick}
      sx={{
        height: "32px",
        maxWidth: maxWidth,
        fontSize: "14px",
        fontWeight: 500,
        textTransform: "none",
        backgroundColor: "var(--base/primary, #18181b)",
        color: "var(--base/primary-foreground, #fafafa)",
        borderRadius: "6px",
        padding: "8px 12px",
        "&:hover": {
          backgroundColor: "#2E7831",
        },
      }}
    >
      {title}
    </Button>
  );
};
